import { PersonDetail } from '../types/personDetail';

export const mockPersonDetails: Record<string, PersonDetail> = {
  '1': {
    id: '1',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@email.com',
    phoneNumber: '(555) 123-4567',
    mobilePhone: '(555) 987-6543',
    workPhone: '(555) 111-2222',
    address: '123 Main St, Springfield, IL 62701',
    mailingAddress: 'PO Box 456, Springfield, IL 62701',
    primaryCampus: 'Springfield Campus',
    givingId: 'GIV-2024-001',
    gender: 'Male',
    maritalStatus: 'Married',
    birthday: 'March 15, 1985',
    anniversary: 'June 20, 2010',
    ethnicity: 'Caucasian',
    baptized: true,
    deceased: false,
    membershipType: 'Member',
    membershipDate: 'January 10, 2015',
    allergies: 'Peanuts',
    confirmedNoAllergies: false,
    emergencyContact: 'Jane Smith',
    emergencyPhone: '(555) 987-6543',
    receiveEmail: true,
    profileListed: true,
    mobileCarrier: 'Verizon',
    familyMembers: [
      { id: 'f1', name: 'Jane Smith', relationship: 'Spouse' },
      { id: 'f2', name: 'Emily Smith', relationship: 'Daughter' },
      { id: 'f3', name: 'Michael Smith', relationship: 'Son' },
    ],
    avatarUrl: 'https://i.pravatar.cc/150?img=12',
    isPrimaryContact: true,
    createdDate: 'September 25, 2012',
    modifiedDate: 'October 15, 2024',
    createdBy: 'Larry Cucumber',
    modifiedBy: 'Larry Cucumber',
    active: true,
  },
  '2': {
    id: '2',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@email.com',
    phoneNumber: '(555) 234-5678',
    address: '456 Oak Ave, Springfield, IL 62702',
    primaryCampus: 'Downtown Campus',
    givingId: 'GIV-2024-002',
    gender: 'Female',
    ethnicity: 'Caucasian',
    familyMembers: [],
    avatarUrl: 'https://i.pravatar.cc/150?img=47',
  },
  '3': {
    id: '3',
    firstName: 'Michael',
    lastName: 'Williams',
    email: 'michael.williams@email.com',
    phoneNumber: '(555) 345-6789',
    address: '789 Elm St, Springfield, IL 62703',
    primaryCampus: 'West Side Campus',
    givingId: 'GIV-2024-003',
    gender: 'Male',
    ethnicity: 'African American',
    familyMembers: [
      { id: 'f4', name: 'Lisa Brown', relationship: 'Spouse' },
    ],
    avatarUrl: 'https://i.pravatar.cc/150?img=3',
  },
};

// Helper function to get person detail by ID
export const getPersonDetailById = (id: string): PersonDetail | undefined => {
  return mockPersonDetails[id];
};
